export function combineRefs<T extends HTMLElement>(...refs: Array<React.Ref<T> | undefined>) {
  return (value: T | null) => {
    for (const ref of refs) {
      if (ref) {
        if (typeof ref === 'function') {
          ref(value);
        } else if ((ref as React.MutableRefObject<T | null>).current !== undefined) {
          (ref as React.MutableRefObject<T | null>).current = value;
        }
      }
    }
  };
}
